import React from "react";

// Before → after table shared by the party details edit modals.
// rows: [{ key, label, before, after }] with display-ready strings.
const EditChangeSummary = ({ rows, beforeLabel, afterLabel }) => (
  <div className="address-edit-summary" role="table">
    <div className="address-edit-summary-row is-header" role="row">
      <span role="columnheader" />
      <span role="columnheader">{beforeLabel}</span>
      <span role="columnheader" aria-hidden="true" />
      <span role="columnheader">{afterLabel}</span>
    </div>
    {rows.map(({ key, label, before, after }) => (
      <div
        key={key}
        className={`address-edit-summary-row${before !== after ? " is-changed" : ""}`}
        role="row"
        data-testid={`summary-${key}`}
      >
        <span role="rowheader" className="address-edit-summary-label">{label}</span>
        <span role="cell" className="address-edit-summary-before">{before}</span>
        <span role="cell" className="address-edit-summary-arrow" aria-hidden="true">→</span>
        <span role="cell" className="address-edit-summary-after">{after}</span>
      </div>
    ))}
  </div>
);

export default EditChangeSummary;
